import { render, staticRenderFns } from "./user-management-layout.vue?vue&type=template&id=b7a2c3a4"
import script from "./user-management-layout.vue?vue&type=script&lang=js"
export * from "./user-management-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports